import { types, Image } from "react-bricks/frontend";
import styled from "styled-components";
import { color } from "styles/colours";
import { backgroundColorProp } from "../utils/backgroundColor";

export interface ImageSectionProps {
  maxWidth?: number;
  backgroundColor?: types.IColor;
}
const ImageSection: types.Brick<ImageSectionProps> = ({ maxWidth, backgroundColor }) => {
  return (
    <Container background={backgroundColor?.color}>
      <Image
        propName="logoImage"
        alt="logoImage"
        maxWidth={maxWidth}
        renderWrapper={({ children }) => (
          <ImageWrapper width={maxWidth ? `${maxWidth}px` : "auto"}>{children}</ImageWrapper>
        )}
        placeholder={() => "/static/bricks/examples/presents.png"}
      />
    </Container>
  );
};

ImageSection.schema = {
  name: "image-section",
  label: "Image Section",
  category: "Images",
  repeaterItems: [],
  getDefaultProps: () => ({
    maxWidth: 640,
    backgroundColor: { color: color.white },
  }),
  sideEditProps: [
    {
      name: "maxWidth",
      label: "Logo image width",
      type: types.SideEditPropType.Number,
    },
    backgroundColorProp,
  ],
};

const Container = styled.div<{ background?: string }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(p) => p.background || `${color.white}`};
`;

const ImageWrapper = styled.div<{ width?: string }>`
  max-width: ${(p) => (p.width ? `${p.width}` : "auto")};
  img {
    max-width: 100%;
    height: auto;
  }
`;

export default ImageSection;
